import { Util } from 'choerodon-ui/shared';
export { MousePosition } from 'choerodon-ui/shared/util';
const getDocument = Util.getDocument;
const getDocuments = Util.getDocuments;
const findIFrame = Util.findIFrame;
const getMousePosition = Util.getMousePosition;
export { getDocument, getDocuments, findIFrame, getMousePosition, };
